import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRotateRight,
  faCalendarDay,
  faComment,
  faEnvelope,
  faHeadset,
  faHeart,
  faMusic,
  faNotdef,
  faPlay,
  faRetweet,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { Avatar, Col, Row, Tooltip } from "antd";
import "./RecommentAndPolicy.css";
import FollowButton from "../FollowButton/FollowButton";
import ToolTipTitle from "../ToolTipTitle/ToolTipTitle";

function RecommentAndPolicy({ type }) {
  return (
    <div className={`RecommentAndPolicy ${type}`}>
      <>
        {type === "inProfilePage" && (
          <Row className="profileInfo">
            <Col span={8} className="profileInfoField">
              <span>Người theo dõi</span>
              {/* <span>332N</span> */}
              <span>{<FontAwesomeIcon icon={faNotdef} />}</span>
            </Col>
            <Col span={8} className="profileInfoField">
              <span>Đang theo dõi</span>
              {/* <span>42</span> */}
              <span>{<FontAwesomeIcon icon={faNotdef} />}</span>
            </Col>
            <Col span={8} className="profileInfoField">
              <span>Số track</span>
              {/* <span>69</span> */}
              <span>{<FontAwesomeIcon icon={faNotdef} />}</span>
            </Col>
          </Row>
        )}
        <Row className="recommend">
          {(type === "inHomepage" || type === "inProfilePage") && (
            <HeaderTitle
              leftIcon={faUserGroup}
              title="Những nghệ sĩ khác"
              rightIcon={faArrowRotateRight}
              button="Làm mới"
              onClick={() => alert("lam moi")}
            />
          )}
          <Col span={24}>
            {(type === "inHomepage" || type === "inProfilePage") && (
              <>
                {[...Array(3)].map((_, index) => (
                  <Row key={index} className="recommendArtist">
                    <Col span={4}>
                      <Avatar
                        src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aXN0fGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                        size={50}
                      />
                    </Col>
                    <Col span={19} offset={1}>
                      <span className="rapName">Ed sheeran</span>
                      <div className="recommendArtistStatus">
                        <div className="rapInfo">
                          <span>
                            <FontAwesomeIcon icon={faUserGroup} /> {1092}
                          </span>
                          <span>
                            <FontAwesomeIcon icon={faMusic} /> {52}
                          </span>
                        </div>
                        <FollowButton />
                      </div>
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </Col>
        </Row>
      </>
      <Row className="listenHistory">
        {type === "inHomepage" && (
          <HeaderTitle
            leftIcon={faCalendarDay}
            title="Lịch sử nghe"
            button="Xem tất cả"
            onClick={() => alert("Lịch sử nghe")}
          />
        )}
        {type === "inPlaylistPage" && (
          <HeaderTitle
            title="Các track liên quan"
            button="Xem tất cả"
            onClick={() => alert("lam moi")}
          />
        )}
        <Col span={24}>
          {(type === "inHomepage" || type === "inPlaylistPage") && (
            <>
              {[...Array(3)].map((_, index) => (
                <Row key={index} className="listenHistoryItem">
                  <Col span={4}>
                    <img
                      src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aXN0fGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                      alt=""
                      className="listenHistoryImg"
                    />
                  </Col>
                  <Col span={19} offset={1}>
                    <span className="rapNameWrapper">
                      <Tooltip
                        placement="bottom"
                        color="white"
                        overlayStyle={{ width: "150px" }}
                        title={
                          <ToolTipTitle
                            avatar="https://picsum.photos/200/300"
                            name="Ed sheeran"
                            followers={1092}
                          />
                        }
                      >
                        <span className="rapNameHover rapName">Ed sheeran</span>
                      </Tooltip>
                      <span className="rapNameHover">
                        <FontAwesomeIcon icon={faMusic} />
                      </span>
                    </span>
                    <span className="rapName">Shape of you</span>
                    <div className="rapInfo">
                      <span>
                        <FontAwesomeIcon icon={faPlay} /> {1092}
                      </span>
                      <span>
                        <FontAwesomeIcon icon={faHeart} /> {52}
                      </span>
                      <span>
                        <FontAwesomeIcon icon={faComment} /> {328}
                      </span>
                      <span>
                        <FontAwesomeIcon icon={faRetweet} /> {34}
                      </span>
                    </div>
                  </Col>
                </Row>
              ))}
            </>
          )}
        </Col>
      </Row>
      <Row className="support">
        <HeaderTitle leftIcon={faEnvelope} title="Hỗ trợ" />
        <Col span={24}>
          <span
            className="supportEmail"
            onClick={() =>
              window.open(
                "https://mail.google.com/mail/?view=cm&fs=1&to=kolab.sup.2802@gmail.com",
                "_blank"
              )
            }
          >
            kolab.sup.2802@gmail.com
          </span>
        </Col>
      </Row>
      <Row className="policy"></Row>
    </div>
  );
}

function HeaderTitle({
  leftIcon = faNotdef,
  title,
  rightIcon = faNotdef,
  button,
  onClick,
}) {
  return (
    <Col span={24}>
      <div className="rapHeader" onClick={onClick}>
        <span className="rapHeaderTitle">
          {leftIcon !== faNotdef && <FontAwesomeIcon icon={leftIcon} />} {title}
        </span>
        <span className="rapHeaderRefresh">
          {rightIcon !== faNotdef && (
            <FontAwesomeIcon className="rightIcon" icon={rightIcon} />
          )}
          {button}
        </span>
      </div>
    </Col>
  );
}

export default RecommentAndPolicy;
